/**
 * 常量字典数据
 */
import Vue from 'vue';

class DictionaryBase extends Map {
  constructor (name, dataList, keyId = 'id', symbolId = 'symbol') {
    super();
    this.showName = name;
    this.setList(dataList, keyId, symbolId);
  }

  setList (dataList, keyId = 'id', symbolId = 'symbol') {
    this.clear();
    if (Array.isArray(dataList)) {
      dataList.forEach((item) => {
        this.set(item[keyId], item);
        if (item[symbolId] != null) {
          Object.defineProperty(this, item[symbolId], {
            get: function () {
              return item[keyId];
            }
          });
        }
      });
    }
  }

  getList (valueId = 'name', parentIdKey = 'parentId', filter) {
    let temp = [];
    this.forEach((value, key) => {
      let obj = {
        id: key,
        name: (typeof value === 'string') ? value : value[valueId],
        parentId: value[parentIdKey],
        disabled: value.disabled || false
      };
      if (typeof filter !== 'function' || filter(obj)) {
        temp.push(obj);
      }
    });

    return temp;
  }

  getValue (id, valueId = 'name') {
    // 如果id为boolean类型，则自动转换为0和1
    if (typeof id === 'boolean') {
      id = id ? 1 : 0;
    }
    return (this.get(id) || {})[valueId];
  }
}

const SysUserStatus = new DictionaryBase('用户状态', [
  {
    id: 0,
    name: '正常状态',
    symbol: 'NORMAL'
  },
  {
    id: 1,
    name: '锁定状态',
    symbol: 'LOCKED'
  }
]);
Vue.prototype.SysUserStatus = SysUserStatus;

const SysUserType = new DictionaryBase('用户类型', [
  {
    id: 0,
    name: '管理员',
    symbol: 'ADMIN'
  },
  {
    id: 1,
    name: '系统操作员',
    symbol: 'SYSTEM'
  },
  {
    id: 2,
    name: '普通操作员',
    symbol: 'OPERATOR'
  }
]);
Vue.prototype.SysUserType = SysUserType;

const YesOrNoDict = new DictionaryBase('是否字典', [
  {
    id: '1',
    name: '是',
    symbol: 'YES'
  },
  {
    id: '0',
    name: '否',
    symbol: 'NO'
  }
]);
Vue.prototype.YesOrNoDict = YesOrNoDict;

const GenderDict = new DictionaryBase('性别字典', [
  {
    id: '1',
    name: '男',
    symbol: 'M'
  },
  {
    id: '0',
    name: '女',
    symbol: 'F'
  }
]);
Vue.prototype.GenderDict = GenderDict;

const RSTypeDict = new DictionaryBase('需求服务类型', [
  {
    id: '1',
    name: '成果',
    symbol: 'CG'
  },
  {
    id: '2',
    name: '培训',
    symbol: 'PX'
  },
  {
    id: '3',
    name: '服务',
    symbol: 'FW'
  },
  {
    id: '4',
    name: '其他',
    symbol: 'QT'
  }
]);
Vue.prototype.RSTypeDict = RSTypeDict;

const InfoTypeDict = new DictionaryBase('信息类型字典', [
  {
    id: '1',
    name: '创新成果',
    symbol: 'CXCG'
  },
  {
    id: '2',
    name: '新闻资讯',
    symbol: 'XWZX'
  },
  {
    id: '3',
    name: '大事记',
    symbol: 'DSJ'
  },
  {
    id: '4',
    name: '政策规范',
    symbol: 'ZCGF'
  }
]);
Vue.prototype.InfoTypeDict = InfoTypeDict;

const AuditStatusDict = new DictionaryBase('审核状态字典', [
  {
    id: '1',
    name: '审核通过',
    symbol: 'SHTG'
  },
  {
    id: '0',
    name: '待审核',
    symbol: 'DSH'
  },
  {
    id: '-1',
    name: '审核不通过',
    symbol: 'SHBTG'
  }
]);
Vue.prototype.AuditStatusDict = AuditStatusDict;

const SpecialistTypeDict = new DictionaryBase('认证类型', [
  {
    id: '1',
    name: '个人',
    symbol: 'PERSON'
  },
  {
    id: '2',
    name: '团队',
    symbol: 'ORG'
  },
  // {
  //   id: '3',
  //   name: '法人',
  //   symbol: 'CEO'
  // },
  {
    id: '4',
    name: '人人都是科特派',
    symbol: 'EVERY'
  }
]);
Vue.prototype.SpecialistTypeDict = SpecialistTypeDict;

const CourseTypeDict = new DictionaryBase('课程类型', [
  {
    id: '1',
    name: '视频课程',
    symbol: 'VIDEO'
  },
  {
    id: '2',
    name: '教学材料',
    symbol: 'TEXT_FILE'
  }
]);
Vue.prototype.CourseTypeDict = CourseTypeDict;

const CreateTypeDict = new DictionaryBase('创建类型', [
  {
    id: '2',
    name: '联络员',
    symbol: 'LLY'
  },
  {
    id: '1',
    name: '特派员',
    symbol: 'TPY'
  }
]);
Vue.prototype.CreateTypeDict = CreateTypeDict;

const MemberTypeDict = new DictionaryBase('站所岗位类型字典', [
  {
    id: '1',
    name: '站长',
    symbol: 'ZZ'
  },
  {
    id: '2',
    name: '驻点专家',
    symbol: 'CY'
  },
  {
    id: '3',
    name: '站所成员',
    symbol: 'HY'
  }
]);
Vue.prototype.MemberTypeDict = MemberTypeDict;

const ScoreDict = new DictionaryBase('学分字典', [
  {
    id: 1,
    name: '一学分',
    symbol: 'ONE'
  },
  {
    id: 2,
    name: '二学分',
    symbol: 'TWO'
  },
  {
    id: 3,
    name: '三学分',
    symbol: 'THREE'
  },
  {
    id: 4,
    name: '四学分',
    symbol: 'FOUR'
  },
  {
    id: 5,
    name: '五学分',
    symbol: 'FIVE'
  }
]);
Vue.prototype.ScoreDict = ScoreDict;
const FilingPassedDict = new DictionaryBase('备案状态字典', [
  {
    id: '-1',
    name: '备案不通过',
    symbol: 'NO'
  },
  {
    id: '0',
    name: '待备案',
    symbol: 'PRE'
  },
  {
    id: '1',
    name: '备案通过',
    symbol: 'YES'
  }
]);
Vue.prototype.FilingPassedDict = FilingPassedDict;
const DegreeLevelDict = new DictionaryBase('学位字典', [
  {
    id: '1',
    name: '博士',
    symbol: 'DOCTOR'
  },
  {
    id: '2',
    name: '硕士',
    symbol: 'MASTERS'
  },
  {
    id: '3',
    name: '学士',
    symbol: 'BACHELOR'
  },
  {
    id: '4',
    name: '其他',
    symbol: 'OTHER'
  }
]);
Vue.prototype.DegreeLevelDict = DegreeLevelDict;

const CollectTypeDict = new DictionaryBase('收藏分类', [
  {
    id: '1',
    name: '专家',
    symbol: 'ZJ'
  },
  {
    id: '2',
    name: '成果体现',
    symbol: 'CGTX'
  },
  {
    id: '3',
    name: '创新改革',
    symbol: 'CXGG'
  },
  {
    id: '4',
    name: '新闻资讯',
    symbol: 'XWZX'
  },
  {
    id: '5',
    name: '大事记',
    symbol: 'DSJ'
  },
  {
    id: '6',
    name: '特派员规范',
    symbol: 'TPYGF'
  },
  {
    id: '7',
    name: '问答',
    symbol: 'WD'
  }
]);
Vue.prototype.CollectTypeDict = CollectTypeDict;

const ValidityDict = new DictionaryBase('需求有效期', [
  {
    id: '1',
    name: '半年',
    symbol: 'BN'
  },
  {
    id: '2',
    name: '一年',
    symbol: 'YN'
  },
  {
    id: '3',
    name: '长期',
    symbol: 'CQ'
  }
]);
Vue.prototype.ValidityDict = ValidityDict;

const OpenDict = new DictionaryBase('是否公开', [
  {
    id: '0',
    name: '否',
    symbol: 'F'
  },
  {
    id: '1',
    name: '是',
    symbol: 'S'
  }
]);
Vue.prototype.OpenDict = OpenDict;

const IdentityDict = new DictionaryBase('身份字典', [
  {
    id: '4',
    name: '留学、归国人员',
    symbol: 'LS'
  },
  {
    id: '2',
    name: '外籍人员',
    symbol: 'WJ'
  },
  {
    id: '3',
    name: '台港澳人员',
    symbol: 'TGA'
  },
  {
    id: '1',
    name: '境内人员',
    symbol: 'JN'
  }
]);
Vue.prototype.IdentityDict = IdentityDict;

const DocumentTypeDict = new DictionaryBase('证件类型', [
  {
    id: '1',
    name: '身份证',
    symbol: 'SFZ'
  },
  {
    id: '2',
    name: '香港身份证',
    symbol: 'XGSFZ'
  },
  {
    id: '3',
    name: '澳门身份证',
    symbol: 'AMSFZ'
  },
  {
    id: '4',
    name: '台胞证',
    symbol: 'TBZ'
  },
  {
    id: '5',
    name: '护照',
    symbol: 'HZ'
  },
  {
    id: '6',
    name: '军人证',
    symbol: 'JRZ'
  },
  {
    id: '7',
    name: '其它',
    symbol: 'QT'
  }
]);
Vue.prototype.DocumentTypeDict = DocumentTypeDict;

const DistrictDict = new DictionaryBase('是否区级字典', [
  {
    id: '1',
    name: '区级',
    symbol: 'S'
  },
  {
    id: '0',
    name: '非区级',
    symbol: 'F'
  }
]);
Vue.prototype.DistrictDict = DistrictDict;

const IsDockingDict = new DictionaryBase('对接状态字典', [
  {
    id: 0,
    name: '未对接',
    symbol: 'WDJ'
  },
  {
    id: 1,
    name: '已对接',
    symbol: 'YDJ'
  }
  // ,
  // {
  //   id: 2,
  //   name: '对接中',
  //   symbol: 'DJZ'
  // }
]);
Vue.prototype.IsDockingDict = IsDockingDict;

const SysOperationType = new DictionaryBase('操作日志操作类型', [
  {
    id: 0,
    name: '登录',
    symbol: 'LOGIN'
  },
  {
    id: 5,
    name: '登出',
    symbol: 'LOGOUT'
  },
  {
    id: 10,
    name: '新增',
    symbol: 'ADD'
  },
  {
    id: 15,
    name: '修改',
    symbol: 'UPDATE'
  },
  {
    id: 20,
    name: '删除',
    symbol: 'DELETE'
  },
  {
    id: 35,
    name: '查询',
    symbol: 'LIST'
  },
  {
    id: 40,
    name: '分组查询',
    symbol: 'LIST_WITH_GROUP'
  },
  {
    id: 45,
    name: '导出',
    symbol: 'EXPORT'
  },
  {
    id: 25,
    name: '新增多对多关联',
    symbol: 'ADD_M2M'
  },
  {
    id: 30,
    name: '移除多对多关联',
    symbol: 'DELETE_M2M'
  },
  {
    id: 50,
    name: '上传',
    symbol: 'UPLOAD'
  },
  {
    id: 55,
    name: '下载',
    symbol: 'DOWNLOAD'
  },
  {
    id: 60,
    name: '重置缓存',
    symbol: 'RELOAD_CACHE'
  }
]);
Vue.prototype.SysOperationType = SysOperationType;

const SysPermModuleType = new DictionaryBase('权限分组类型', [
  {
    id: 0,
    name: '分组模块',
    symbol: 'GROUP'
  }, {
    id: 1,
    name: '接口模块',
    symbol: 'CONTROLLER'
  }
]);
Vue.prototype.SysPermModuleType = SysPermModuleType;

const SysPermCodeType = new DictionaryBase('权限字类型', [{
  id: 0,
  name: '表单',
  symbol: 'FORM'
}, {
  id: 1,
  name: '片段',
  symbol: 'FRAGMENT'
}, {
  id: 2,
  name: '操作',
  symbol: 'OPERATION'
}]);
Vue.prototype.SysPermCodeType = SysPermCodeType;

const SysMenuType = new DictionaryBase('菜单类型', [
  {
    id: 0,
    name: '目录',
    symbol: 'DIRECTORY'
  },
  {
    id: 1,
    name: '表单',
    symbol: 'MENU'
  },
  {
    id: 2,
    name: '片段',
    symbol: 'FRAGMENT'
  },
  {
    id: 3,
    name: '按钮',
    symbol: 'BUTTON'
  }
]);
Vue.prototype.SysMenuType = SysMenuType;

const SysMenuBindType = new DictionaryBase('菜单绑定类型', [
  {
    id: 0,
    name: '路由菜单',
    symbol: 'ROUTER'
  },
  {
    id: 1,
    name: '在线表单',
    symbol: 'ONLINE_FORM'
  },
  {
    id: 2,
    name: '工单列表',
    symbol: 'WORK_ORDER'
  }
]);
Vue.prototype.SysMenuBindType = SysMenuBindType;

const SysDataPermType = new DictionaryBase('数据权限类型', [
  {
    id: 0,
    name: '查看全部',
    symbol: 'ALL'
  },
  {
    id: 1,
    name: '仅看自己',
    symbol: 'ONLY_USER'
  },
  {
    id: 2,
    name: '仅看所在部门',
    symbol: 'ONLY_DEPT'
  },
  {
    id: 3,
    name: '仅看所在部门及子部门',
    symbol: 'ONLY_DEPT_AND_CHILD'
  },
  {
    id: 4,
    name: '自选部门及子部门',
    symbol: 'CUSTOM_DEPT_AND_CHILD'
  },
  {
    id: 5,
    name: '仅自选部门',
    symbol: 'CUSTOM_DEPT'
  }
]);
Vue.prototype.SysDataPermType = SysDataPermType;
const EducationDict = new DictionaryBase('学历字典', [
  {
    id: '1',
    name: '博士',
    symbol: 'BS'
  },
  {
    id: '2',
    name: '硕士',
    symbol: 'SS'
  },
  {
    id: '3',
    name: '本科',
    symbol: 'BK'
  },
  {
    id: '4',
    name: '大专',
    symbol: 'DZ'
  },
  {
    id: '5',
    name: '中专/高中',
    symbol: 'ZZ'
  },
  {
    id: '6',
    name: '其他',
    symbol: 'QT'
  }
]);
Vue.prototype.EducationDict = EducationDict;
const AppropriateChannelDict = new DictionaryBase('拨款渠道字典', [
  {
    id: '1',
    name: '工作单位',
    symbol: 'GZ'
  },
  {
    id: '2',
    name: '服务单位',
    symbol: 'FW'
  }
]);
Vue.prototype.AppropriateChannelDict = AppropriateChannelDict;

const ProcessDefinitionTypeDict = new DictionaryBase('流程类型字典', [
  {
    id: 'flowRequirementAudit',
    name: '需求审核',
    symbol: 'XQ'
  },
  {
    id: 'flowSpecialistInfo',
    name: '科特派认证审核',
    symbol: 'ZHL'
  },
  {
    id: 'flowSpecialistEveryAudit',
    name: '人人都是科特派认证审核',
    symbol: 'JNL'
  },
  {
    id: 'flowNewsAudit',
    name: '新闻内容审核',
    symbol: 'XW'
  },
  {
    id: 'flowRequirementRelateAudit',
    name: '需求对接审核',
    symbol: 'XQDJ'
  },
  {
    id: 'technologyTrainFlow',
    name: '科技培训审核',
    symbol: 'KJPX'
  },
  {
    id: 'flowWorkInformation',
    name: '工作日志审核',
    symbol: 'GZRZ'
  },
  {
    id: 'flowService',
    name: '服务审核',
    symbol: 'FW'
  },
  {
    id: 'flowAreaWork',
    name: '辖区工作审核',
    symbol: 'XQGZ'
  },
  {
    id: 'flowActivity',
    name: '辖区活动审核',
    symbol: 'xhd'
  },
  {
    id: 'flowConsult',
    name: '问答审核',
    symbol: 'WD'
  }
]);
Vue.prototype.ProcessDefinitionTypeDict = ProcessDefinitionTypeDict;
const RepeatDate = new DictionaryBase('重复日期', [
  {
    id: '1',
    name: '周一',
    symbol: 'MONDAY'
  },
  {
    id: '2',
    name: '周二',
    symbol: 'TUESDAY'
  },
  {
    id: '3',
    name: '周三',
    symbol: 'WEDNESDAY'
  },
  {
    id: '4',
    name: '周四',
    symbol: 'THURSDAY'
  },
  {
    id: '5',
    name: '周五',
    symbol: 'FRIDAY'
  },
  {
    id: '6',
    name: '周六',
    symbol: 'SATURDAY'
  },
  {
    id: '0',
    name: '周日',
    symbol: 'SUNDAY'
  }
]);
Vue.prototype.RepeatDate = RepeatDate;

const ServiceType = new DictionaryBase('服务方式', [
  {
    id: '1',
    name: '电话咨询',
    symbol: 'PHONE'
  }
]);
Vue.prototype.ServiceType = ServiceType;
const IntegralType = new DictionaryBase('积分类型', [
  {
    id: '1',
    name: '需求问答',
    symbol: 'HD'
  },
  {
    id: '2',
    name: '服务',
    symbol: 'DZ'
  },
  {
    id: '3',
    name: '活动',
    symbol: 'PL'
  },
  {
    id: '4',
    name: '技术需求',
    symbol: 'GZRZ'
  },
  {
    id: '5',
    name: '科技培训',
    symbol: 'XY'
  },
  {
    id: '6',
    name: '推广',
    symbol: 'TG'
  },
  {
    id: '7',
    name: '工作',
    symbol: 'DL'
  },
  {
    id: '8',
    name: '媒体采用',
    symbol: 'MT'
  },
  {
    id: '8',
    name: '考核',
    symbol: 'KH'
  }
]);
Vue.prototype.IntegralType = IntegralType;

const ParticipantsNumber = new DictionaryBase('参与人数', [
  {
    id: '1',
    name: '5-10',
    symbol: 'A'
  },
  {
    id: '2',
    name: '10-20',
    symbol: 'B'
  },
  {
    id: '3',
    name: '20以上',
    symbol: 'C'
  }
]);
Vue.prototype.ParticipantsNumber = ParticipantsNumber;
export {
  DictionaryBase,
  SysUserStatus,
  SysUserType,
  YesOrNoDict,
  GenderDict,
  RSTypeDict,
  InfoTypeDict,
  AuditStatusDict,
  SpecialistTypeDict,
  CourseTypeDict,
  MemberTypeDict,
  ScoreDict,
  DegreeLevelDict,
  CollectTypeDict,
  ValidityDict,
  OpenDict,
  IdentityDict,
  DocumentTypeDict,
  DistrictDict,
  IsDockingDict,
  SysDataPermType,
  SysOperationType,
  SysPermModuleType,
  SysPermCodeType,
  SysMenuBindType,
  SysMenuType,
  EducationDict,
  AppropriateChannelDict,
  FilingPassedDict,
  ProcessDefinitionTypeDict,
  RepeatDate,
  ServiceType,
  IntegralType,
  ParticipantsNumber,
  CreateTypeDict
}
